// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"f2020e04","275":"176391cb","570":"1935908e","801":"fb44a281"}[chunkId] + ".chunk.css";
};